import { langDb } from '@/utils/index';

export const isTestEnv = () => {
  return location.host.includes('808');

};

export const website = () => {
  return 'https://todo.com/';
};

export const email = () => {
  return 'todo.csr@gmail.com';
};

export const tel = () => {
  return 'xxx';
};

export const officialAddress = () => {
  return 'xxx address';
};

export const companyName = () => {
  return '';
};

export const secNo = () => {
  return '';
};

